module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_a-function.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_a-function.js
// module chunks = 0